// extracted by mini-css-extract-plugin
export default {"Background":"background_Background__C-l-R","backgroundWrapper":"background_backgroundWrapper__tIy9l"};